import { Dropdown } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import { usePostHog } from '@posthog/react';
import authSlice from '../../../../utils/redux/slice/authSlice';
import { authActions } from '../../../../actions/auth';

function UserDropDown({ onNavigate }) {
  const user = useSelector(authSlice.selectors.getUser);
  const posthog = usePostHog();
  const handleLogout = () => {
    posthog?.capture('user_logged_out');
    posthog?.reset();
    authActions.performLogout();
  };

  const initials = (user?.client_name || '?')
    .split(' ')
    .filter(Boolean)
    .map((w) => w[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();

  return (
    <Dropdown
      menu={{
        items: [
          {
            key: 'account',
            label: 'Account Settings',
            onClick: () => onNavigate?.('/account'),
          },
          {
            key: 'brand-dna',
            label: 'Brand DNA',
            onClick: () => onNavigate?.('/brand-dna'),
          },
          { type: 'divider' },
          {
            key: 'logout',
            label: 'Sign Out',
            onClick: handleLogout,
          },
        ],
      }}
      trigger={['click']}
      placement="bottomRight"
    >
      <div
        style={{
          width: 32,
          height: 32,
          borderRadius: 16,
          background: 'linear-gradient(135deg, #FF7E67, #FF4D8D)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          fontSize: 12,
          fontWeight: 600,
          color: '#FFFFFF',
          letterSpacing: '0.02em',
        }}
      >
        {initials}
      </div>
    </Dropdown>
  );
}

export default UserDropDown;
